import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';
import { createCornerValidator } from './validator';

export { parseCornerValue } from './parser';

const cornerAction = {
  ...createDefaultActionDefinition(StylesDerivedNativeActions.cornerStyles),
  validator: createCornerValidator(),
};
export default cornerAction;
